import React from 'react';

type Props = {
  className?: string;
};

const Book: React.FC<Props> = ({ className }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.32 2.31259C5.19094 1.77353 3.61281 1.50947 1.5 1.50009C1.30074 1.49738 1.10539 1.55549 0.940002 1.66665C0.804248 1.75841 0.693122 1.88212 0.616398 2.02691C0.539674 2.17169 0.499704 2.33311 0.500002 2.49697V11.4376C0.500002 12.042 0.930002 12.4979 1.5 12.4979C3.72094 12.4979 5.94875 12.7054 7.28313 13.9667C7.30138 13.984 7.32432 13.9956 7.34911 14C7.37389 14.0044 7.39942 14.0014 7.42253 13.9914C7.44563 13.9814 7.46529 13.9649 7.47907 13.9438C7.49284 13.9227 7.50012 13.8981 7.5 13.8729V3.33822C7.50006 3.26714 7.48485 3.19688 7.45542 3.13218C7.42598 3.06749 7.383 3.00987 7.32938 2.96322C7.02372 2.70191 6.6842 2.48306 6.32 2.31259Z"
        className="fill-primary"
      />
      <path
        d="M15.06 1.66574C14.8945 1.55485 14.6992 1.49707 14.5 1.50011C12.3872 1.50949 10.8091 1.7723 9.68 2.31261C9.31582 2.48278 8.97621 2.7012 8.67031 2.96199C8.61681 3.00872 8.57393 3.06637 8.54456 3.13105C8.51518 3.19573 8.49999 3.26595 8.5 3.33699V13.8723C8.49999 13.8965 8.50711 13.9201 8.52049 13.9403C8.53387 13.9605 8.5529 13.9762 8.57519 13.9856C8.59749 13.995 8.62206 13.9975 8.64582 13.993C8.66958 13.9885 8.69147 13.977 8.70875 13.9601C9.51094 13.1632 10.9188 12.497 14.5013 12.4973C14.7665 12.4973 15.0208 12.3919 15.2084 12.2044C15.3959 12.0169 15.5013 11.7625 15.5013 11.4973V2.4973C15.5016 2.33312 15.4616 2.17138 15.3846 2.02635C15.3076 1.88132 15.1962 1.75747 15.06 1.66574Z"
        className="fill-primary"
      />
    </svg>
  );
};

export default Book;
